<template>
    <div class="mapBox">
      <div class="textBox">
        <div class="title">
          {{ cativeText }}
        </div>
        <div class="textList" v-if="mapImg1 && mapImg1[textListIndex]">
          <div
            class="textList_li"
            v-for="(v, index) in mapImg1[textListIndex].text_List || []"
            :key="index"
            @mouseover="pauseAutoTime"
            @mouseout="resumeAutoTime"
          >
            <img src="@/assets/temimg5/l1-icon.png" alt="" />
            <div class="name" :title="v.schoolName">{{ v.schoolName }}</div>
            <span class="colorText" :title="v.label">{{ v.label }}</span>
          </div>
        </div>
      </div>
      <img
        v-for="(v, index) in mapImg1"
        :key="index + v.city_name"
        :src="getImg(v.img)"
        alt=""
        class="mapimg"
        v-show="v.city_show"
      />
      <div
        class="title_active"
        v-for="(v, index) in mapImg1"
        :key="index + v.img"
        @mouseover="mouseoverText(v.city_name, index, $event)"
        @mouseout="mouseoutText(index)"
        v-show="v.textShow"
        :style="{ top: v.text_top + 'px', left: v.text_left + 'px' }"
      >
        {{ v.city_name }}
      </div>
      <div class="active" :style="{ top: top, left: left }">
        <span>
          {{ cativeText }}
        </span>
      </div>
    </div>
  </template>
  <script>
  import dongying from "./dongying.json";
  import * as methods from "../scope/method.js";
  export default {
    name: "template.scope1.center2",
    props: {
      vdata: {
        type: [Array, String],
        default: () => [],
      },
      jsondata: {
        type: [Array, String],
        default: () => [],
      },
      scopedata: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        title: "地图山东东营区-scope__",
        timer: null,
        defaultdata: [
          { value1: "学校一", value2: "东城街道", value3: "重点" },
          { value1: "学校二", value2: "东城街道", value3: "" },
          { value1: "学校三", value2: "东城街道", value3: "" },
          { value1: "学校四", value2: "东城街道", value3: "特殊" },
          { value1: "学校五", value2: "东城街道", value3: "" },
          { value1: "学校六", value2: "东城街道", value3: "" },
          { value1: "学校七", value2: "东城街道", value3: "" },
          { value1: "学校一", value2: "黄河路街道", value3: "" },
          { value1: "学校二", value2: "黄河路街道", value3: "特殊" },
          { value1: "学校三", value2: "黄河路街道", value3: "" },
          { value1: "学校一", value2: "六户镇", value3: "" },
          { value1: "学校二", value2: "六户镇", value3: "" },
          { value1: "学校三", value2: "六户镇", value3: "重点" },
          { value1: "学校一", value2: "龙居镇", value3: "" },
          { value1: "学校二", value2: "龙居镇", value3: "" },
          { value1: "学校三", value2: "龙居镇", value3: "重点" },
          { value1: "学校四", value2: "龙居镇", value3: "重点" },
          { value1: "学校一", value2: "牛庄镇", value3: "" },
          { value1: "学校二", value2: "牛庄镇", value3: "" },
          { value1: "学校三", value2: "牛庄镇", value3: "" },
          { value1: "学校一", value2: "胜利街道", value3: "" },
          { value1: "学校二", value2: "胜利街道", value3: "特殊" },
          { value1: "学校三", value2: "胜利街道", value3: "" },
          { value1: "学校一", value2: "胜园街道", value3: "" },
          { value1: "学校二", value2: "胜园街道", value3: "" },
          { value1: "学校三", value2: "胜园街道", value3: "" },
          { value1: "学校四", value2: "胜园街道", value3: "" },
          { value1: "学校一", value2: "史口镇", value3: "" },
          { value1: "学校二", value2: "史口镇", value3: "重点" },
          { value1: "学校三", value2: "史口镇", value3: "" },
          { value1: "学校一", value2: "文汇街道", value3: "重点" },
          { value1: "学校二", value2: "文汇街道", value3: "重点" },
          { value1: "学校三", value2: "文汇街道", value3: "重点" },
          { value1: "学校一", value2: "辛店街道", value3: "" },
          { value1: "学校二", value2: "辛店街道", value3: "特殊 " },
          { value1: "学校三", value2: "辛店街道", value3: "" },
        ],
        valueMap: [
          { name: "学校", key: "value1" },
          { name: "地区", key: "value2" },
          { name: "标注", key: "value3" },
        ],
        exceldata: [],
        apiconfig: {},
        isApi: false,
        scope: {},
        config: {},
        top: "327px", //70
        left: "540px", //60
        cativeText: "东城街道",
        Time: null,
        textListIndex: 0,
        mapImg1: [],
        localDongying: null,
        autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
      };
    },
    watch: {
      vdata(n) {
        if (n && n.length) {
          this.defaultdata = n;
          this.addDataToTextList(); // 当 vdata 更新时，重新添加数据到 text_List
        }
      },
      jsondata(n) {
        this.exceldata = n;
      },
      defaultdata(n) {
        this.addDataToTextList(); // 当 vdata 更新时，重新添加数据到 text_List
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    methods: {
      ...methods,
      setData() {
        let { apiconfig, isApi, isExcel, exceldata, vdata } = this.scopedata;
        apiconfig && (this.apiconfig = apiconfig);
        this.isApi = isApi;
        this.isExcel = isExcel;
        exceldata &&
          (this.exceldata = exceldata)(vdata && vdata.length) &&
          (this.defaultdata = vdata);
        this.scope = JSON.stringify(this.scopedata);
        if (this.apiconfig && this.isApi) {
          this.getfromApi(this.apiconfig);
        }
      },
      mouseoverText(name, index, e) {
        let dom = e.target;
        this.textListIndex = index;
        this.cativeText = name;
        clearTimeout(this.Time);
        // console.log(name, dom);
        this.mapImg1.forEach((i) => {
          if (i.city_name == name) {
            // console.log(name, i.city_name, this.textListIndex, "chenggong");
            i.textShow = false;
            i.city_show = true;
            this.cativeText = name;
            this.top = parseInt(dom.style.top.match(/\d+/)[0]) - 50 + "px";
            this.left = parseInt(dom.style.left.match(/\d+/)[0]) - 50 + "px";
          } else {
            i.textShow = true;
            i.city_show = false;
          }
        });
      },
      mouseoutText(index) {
        this.autoTime(index + 1);
      },
      autoTime(index = 0) {
        let times = index;
        this.Time = setInterval(() => {
          if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
          if (times >= this.mapImg1.length) {
            times = 0;
          }
          this.textListIndex = times;
          this.mapImg1.forEach((item, index) => {
            if (index == times) {
              item.textShow = false;
              item.city_show = true;
              this.cativeText = item.city_name;
              this.top = item.city_top + "px";
              this.left = item.city_left + "px";
              // }
            } else {
              item.textShow = true;
              item.city_show = false;
            }
          });
          times++;
          if (times > this.mapImg1.length) {
            times = 0;
          }
        }, 3000);
      },
      getImg(url) {
        return require(`@/assets/temimg5//${url}`);
      },
      // fetchDongyingData() {
      //   return new Promise((resolve) => {
      //     // 模拟异步操作
      //     setTimeout(() => {
      //       this.localDongying = JSON.parse(JSON.stringify(dongying));
      //       resolve(this.localDongying);
      //     }, 1000);
      //   });
      // },
      addDataToTextList() {
        // 清空原有的 text_List 数据
        if (this.localDongying) {
          this.localDongying.defaultdata[0].child.forEach((item) => {
            item.text_List = [];
          });
  
          this.defaultdata.forEach((school) => {
            const street = school.value2;
            const streetObj = this.localDongying.defaultdata[0].child.find(
              (item) => item.city_name === street
            );
            if (streetObj) {
              streetObj.text_List.push({
                schoolName: school.value1,
                label: school.value3,
              });
            }
          });
  
          this.mapImg1 = [...this.localDongying.defaultdata[0].child];
          // console.log(this.mapImg1);
        }
      },
      pauseAutoTime() {
        this.autoTimePaused = true; // 标记定时器暂停
      },
      resumeAutoTime() {
        this.autoTimePaused = false; // 标记定时器恢复
      },
    },
    async mounted() {
      if (this.vdata && this.vdata.length) {
        this.defaultdata = this.vdata;
      }
      if (this.jsondata && this.jsondata.length) {
        this.exceldata = this.jsondata;
      }
      this.localDongying = JSON.parse(JSON.stringify(dongying));
      // await this.fetchDongyingData();
      this.addDataToTextList(); // 在组件挂载时添加数据到 text_List
      this.autoTime();
    },
    beforeDestroy() {
      clearInterval(this.Time);
    },
  };
  </script>
  <style lang="scss" scoped>
  .mapBox {
    width: 950px;
    height: 900px !important;
    position: relative;
    background: url("@/assets/temimg5/zgeMap.png") no-repeat;
    background-size: 100% 100%;
    margin-left: -20px;
    margin-top: -130px;
    pointer-events: auto;
    .c1-title {
      width: 188.5px;
      height: 40.5px;
      position: relative;
      line-height: 40.5px;
      font-size: 18px;
      text-align: center;
      font-style: italic;
      font-weight: 400;
      margin-left: 60px;
      font-family: "bmzy";
      top: 100px;
    }
  
    .map-title-img {
      width: 188.5px;
      height: 40.5px;
      left: 0;
      position: absolute;
    }
  
    .title_active {
      font-family: "bmzy";
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      position: absolute;
      z-index: 102;
    }
  
    .active {
      width: 156px;
      height: 151px;
      background: url("@/assets/temimg5/active.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      z-index: 103;
      font-family: "bmzy";
      font-size: 16px;
      color: #925b00;
      cursor: pointer;
  
      span {
        display: flex;
        width: 120px;
        height: 24px;
        font-family: "bmzy";
        position: absolute;
        top: 42px;
        left: 50%;
        justify-content: center;
        align-items: center;
        transform: translateX(-50%);
      }
    }
  
    .mapimg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0%;
      z-index: 2;
    }
  
    .textBox {
      min-width: 261px;
      height: 150px;
      position: absolute;
      bottom: 6%;
      right: 10%;
      background: url("@/assets/temimg5/tooltip.png") no-repeat;
      background-size: 100% 100%;
      z-index: 1;
      padding: 10px 20px;
      box-sizing: border-box;
      color: #fff;
      font-size: 14px;
      line-height: 30px;
      text-align: left;
      z-index: 120;
      cursor: pointer;
  
      .title {
        color: #fff;
        font-size: 18px;
        width: 120px;
        font-family: "本墨字语";
        margin: -5px 0 0 -8px;
        // background: pink;
        text-align: center;
        // padding: 0 0 0 0px;
      }
  
      .textList {
        width: 100%;
        height: 160px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
      }
      .textList::-webkit-scrollbar {
        width: 0; /* 隐藏垂直滚动条 */
        height: 0; /* 隐藏水平滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 和 Edge */
      }
  
      .textList_li:first-child {
        margin-top: 14px;
      }
  
      .textList_li {
        font-size: 14px;
        color: #d0f7fe;
        display: flex;
  
        img {
          width: 20px;
          height: fit-content;
          margin-right: 8px;
        }
        .name {
          max-width: 140px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .colorText {
          color: #458ef7;
          margin-left: 8px;
        }
      }
    }
  }
  </style>
  